import { enableProdMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, withEnabledBlockingInitialNavigation } from '@angular/router';
import { AgrBrowserModule } from '@next/core-lib/browser';
import { provideAgrElasticApi } from '@next/core-lib/elastic';

import { APP_BROWSER_RUNTIME_PROVIDERS, setupRuntimeConfig } from './app/app.browser.module';
import { AppComponent } from './app/app.component';
import { AppModule } from './app/app.module';
import { appRoutes } from './app/app.routes';
import { environment } from './environments/environment';

if (environment.PRODUCTION) {
  enableProdMode();
}

setupRuntimeConfig
  .then(() =>
    bootstrapApplication(AppComponent, {
      providers: [
        provideRouter(appRoutes, withEnabledBlockingInitialNavigation()),
        importProvidersFrom(AppModule, AgrBrowserModule),
        provideAgrElasticApi(),
        ...APP_BROWSER_RUNTIME_PROVIDERS,
      ],
    }),
  )
  .catch((err) => console.error(err));
